/* BaseLogsViewRenderer.js */

'use strict';

const LogsControlComponent = require("@gluenetworks/logs_control").LogsControlComponent;

class BaseLogsViewRenderer {

    constructor(model) {
        this._model = model;
        this._logsControl = new LogsControlComponent({logLevels: this._model.logLevels, logSequence: this._model.logSequence, actionBarVisible: false});
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        this._unregisterListeners();
        this._model = undefined;
        this._resizeObserver = undefined;
        return this._logsControl.shutdown().then(() => {
            this._logsControl = undefined;
        });
    }

    _registerListeners() {
        this._resizeObserver = new ResizeObserver(this._onResize = this._onResize.bind(this));
        this._resizeObserver.observe(this._rootElem);
        this._model.on("LogLevels", this._onLogLevels = this._onLogLevels.bind(this));
        this._model.on("LogSequence", this._onLogSequence = this._onLogSequence.bind(this));
        this._model.on("ScrollLock", this._onScrollLock = this._onScrollLock.bind(this));
        this._logsControl.on("logFiltersChanged", this._onLogLevelsChangedByUser = this._onLogLevelsChangedByUser.bind(this));
        this._logsControl.on("logSequenceChanged", this._onLogSequenceChangedByUser = this._onLogSequenceChangedByUser.bind(this));
        this._logsControl.on("scrollLockChanged", this._onScrollLockChangedByUser = this._onScrollLockChangedByUser.bind(this));
        this._model.gameEditor._editorLayout.on("ActiveTabChanged", (this._onActiveTabChanged = this._onActiveTabChanged.bind(this)));
    }

    _unregisterListeners() {
        this._resizeObserver.disconnect();
        this._model.removeListener("LogLevels", this._onLogLevels);
        this._model.removeListener("LogSequence", this._onLogSequence);
        this._model.removeListener("ScrollLock", this._onScrollLock);
        this._logsControl.removeListener("logFiltersChanged", this._onLogLevelsChangedByUser);
        this._logsControl.removeListener("logSequenceChanged", this._onLogSequenceChangedByUser);
        this._logsControl.removeListener("scrollLockChanged", this._onScrollLockChangedByUser);
        this._model.gameEditor._editorLayout.removeListener("ActiveTabChanged", this._onActiveTabChanged);
    }

    _registerViewActions() {
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Show Settings",
            name: "show_settings",
            position: "left",
            handler: this._onLogSettingsButtonClick.bind(this)
        });
        this._model.gameEditor.addViewAction({
            type: "normal",
            displayName: "Hide Settings",
            name: "hide_settings",
            position: "left",
            handler: this._onLogSettingsButtonClick.bind(this)
        });
        this._model.gameEditor.hideViewAction("hide_settings");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onLogLevels(logLevels) {
        if(this._logsControl) {
            this._logsControl.setLogLevels(logLevels);
        }
    }

    _onLogSequence(logSequence) {
        this._logsControl.setLogSequence(logSequence);
    }

    _onScrollLock(scrollLock) {
        this._logsControl.setScrollLock(scrollLock);
    }

    _onLogLevelsChangedByUser(logLevels) {
        this._model._updateLogLevelPreferences(logLevels);
    }

    _onLogSequenceChangedByUser(logSequence) {
        this._model._updateLogSequencePreference(logSequence);
    }

    _onScrollLockChangedByUser(scrollLock) {
        this._model._updateScrollLockPreference(scrollLock);
    }

    _onActiveTabChanged(activeTabId) {
        if(activeTabId === this._model.gameEditor._tabId) {
            this._resizeLogsControl();
        }
    }

    _onResize() {
        this._resizeLogsControl();
    }

    _onLogSettingsButtonClick() {
        if(this._logsControl) {
            if(this._logsControl.isActionBarVisible()) {
                this._model.gameEditor.showViewAction('show_settings');
                this._model.gameEditor.hideViewAction('hide_settings');
                this._logsControl.setActionBarVisible(false);
            } else {
                this._model.gameEditor.hideViewAction('show_settings');
                this._model.gameEditor.showViewAction('hide_settings');
                this._logsControl.setActionBarVisible(true);
            }
        }
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _resizeLogsControl() {
        this._logsControl.setControlHeight(this._rootElem.clientHeight - 45);
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = BaseLogsViewRenderer;
